export default __webpack_public_path__ + "static/media/PPI-firefeature-008.ff4f8e55.jpg";